// src/components/business/BizModal.tsx
//
// Shell de modal das telas de Negócios (correção UX v2): mecanismo Radix
// (portal/overlay/foco/Escape) + caixa visual do wireframe (WfModal —
// dialog .dl-h/.dl-b/.dl-f) com .wf-modal-backdrop no overlay, conforme o
// contrato documentado em src/components/wf/WfModal.tsx.

import * as React from 'react';
import * as DialogPrimitive from '@radix-ui/react-dialog';
import { WfModal } from '@/components/wf';

export interface BizModalProps {
  open: boolean;
  /** Fechamento (X, Escape, clique no backdrop). */
  onClose: () => void;
  title: React.ReactNode;
  icon?: React.ReactNode;
  footer?: React.ReactNode;
  wide?: boolean;
  children: React.ReactNode;
}

export function BizModal({ open, onClose, title, icon, footer, wide, children }: BizModalProps) {
  return (
    <DialogPrimitive.Root open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay className="fixed inset-0 z-[400] wf-modal-backdrop" />
        <DialogPrimitive.Content
          className="fixed left-1/2 top-1/2 z-[400] -translate-x-1/2 -translate-y-1/2 outline-none"
          aria-describedby={undefined}
        >
          <WfModal
            title={<DialogPrimitive.Title asChild><span>{title}</span></DialogPrimitive.Title>}
            icon={icon}
            onClose={onClose}
            footer={footer}
            wide={wide}
          >
            {children}
          </WfModal>
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  );
}
